import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';


import { HttpClient } from '@angular/common/http';
import { DomSanitizer } from '@angular/platform-browser';
import { EventResponseType } from 'common/models/common/enums';
import { ModalData, ADPResourceService as ResourceService } from 'digital-core';
import { ConfigService } from '../../services/config.service';
import { InMemoryPdfService } from '../../services/InMemoryPdfService.service';
@Component({
  selector: 'adp-modal',
  templateUrl: './adp-modal.component.html',
  styleUrls: ['./adp-modal.component.css'],

})
export class adpModalComponent implements OnInit, AfterViewInit {
  errorId = null;
  isAcknowledgeChecked: boolean = false;
  iframeUrl: any;
  popupOriginalSizeSetting: boolean = false;
  public appealModal: any = String(false);
  @ViewChild('risk-score') risk: ElementRef;
  @ViewChild('pdfViewer') public pdfViewer;
  totalPages: number;

  constructor(public thisDialogRef: MatDialogRef<adpModalComponent>,
    private configService: ConfigService,
    public resourceService: ResourceService,
    private sanitizer: DomSanitizer,
    private http: HttpClient,
    @Inject(MAT_DIALOG_DATA) public data: ModalData,
    private cd: ChangeDetectorRef,
    private inMemoryPdfService: InMemoryPdfService
  
  ) {
    thisDialogRef.disableClose = true;
    if (this.data.error && this.data.error.hasOwnProperty('errorId')) {
      this.errorId = this.data.error['errorId'];
    }
  }

  ngOnInit() {
     if(this.data != null && this.data.IframeUrl != null && this.inMemoryPdfService.getPdfData() != null){
      const pdfData = this.inMemoryPdfService.getPdfData();
      if(pdfData){
          const blob = new Blob([pdfData], {type:'application/pdf'});
          this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(URL.createObjectURL(blob));
      }
    }
    if(this.resourceService.getPortalSetting("Global_TnC_EC_Popup_original-size_setting")?.Value){
      this.popupOriginalSizeSetting = JSON.parse(this.resourceService.getPortalSetting("Global_TnC_EC_Popup_original-size_setting")?.Value);
    }
    
  }

  ngAfterViewInit(): void {
    if (this.pdfViewer &&  this.data.IframeUrl != null &&  this.inMemoryPdfService.getPdfData() != null) {
     
          this.cd.detectChanges();
         }
   
  }

  pdfLoad(totalPages: number) {
    this.totalPages = totalPages;
  }
  lastPageEventClicked(event:boolean){
    let acceptButton = this.data.ControlArray.find(x => x.Action == EventResponseType.Accept);
    if(event){
   
      if (acceptButton && acceptButton.isDisabled) {
        acceptButton.isDisabled = false;
      }
    } else{
      acceptButton.isDisabled = true;
    }
  }

  pdfPageChange(pageNo: any) {
    if (pageNo == this.totalPages) {
      let acceptButton = this.data.ControlArray.find(x => x.Action == EventResponseType.Accept);
      if (acceptButton && acceptButton.isDisabled) {
        acceptButton.isDisabled = false;
      }
    }
  }

  isAcknoladge($event: any) {
    this.isAcknowledgeChecked = !this.isAcknowledgeChecked;
    this.data.ControlArray.forEach(element => {
      element.isDisabled = this.isAcknowledgeChecked ? false : true;
    });
  }
  showError() {
    return typeof this.data.error !== 'undefined' && this.data.error !== null && !this.configService.isProduction;
  }

  getErrorMessage() {
    let msg = '';
    if (this.data.error && this.data.error.hasOwnProperty('message')) {
      msg = this.data.error.message;
    }
    return msg;
  }

  onClose(value: string) {
    this.thisDialogRef.close(value);
  }
}
